import chroma from "chroma-js";

/**
 * @param {object} param
 * @param {string} param.color - The color to check
 * @returns {boolean} - True if the color is near black, false otherwise
 */
export function isNearBlack({ color }) {
  if (!color) throw new Error("A color is required");
  if (typeof color !== "string") throw new Error("Color must be a string");

  const distanceFromBlack = chroma.deltaE(color, "black");
  const threshold = 20;
  return distanceFromBlack < threshold;
}
